import {GMN, GMN_PATH} from './commonConst.js';
/**
  * TODO 上長、担当の区別項目無し
  * @return  {object}
  */
export function dashbordInfo() {
  const DashBord = [
    {
      title: 'ダッシュボード',
      parts: [
        [
          {
            title: '担当者',
            gmnId: GMN.TSTK_KASYO_LIST.id,
            visible: true,
            pathname: GMN_PATH.TSTK_KASYO_LIST,
            cnt: {
              apiTitle: '調査',
              apiName: 'approvalCount',
              condition: {},
            },
            expired: {
              apiTitle: '点検',
              apiName: 'expiredCount',
              condition: {},
            },
            flag: true,
          },

          {
            title: '上長',
            gmnId: GMN.TSTK_KASYO_LIST.id,
            visible: true,
            pathname: GMN_PATH.TSTK_KASYO_LIST,
            cnt: {
              apiTitle: '調査',
              apiName: 'approvalCount',
              condition: {},
            },
            expired: {
              apiTitle: '点検',
              apiName: 'expiredCount',
              condition: {},
            },
            flag: true,
          },

          {
            title: '調査・点検対象管理',
            visible: true,
            gmnId: GMN.APPLICATION_APPROVAL_LIST.id,
            pathname: GMN_PATH.APPLICATION_APPROVAL_LIST,
            cnt: {
              apiName: 'approvalCount',
              condition: {},
            },
            expired: {
              apiName: 'expiredCount',
              condition: {},
            },
            flag: false,
          },
        ],
      ],
    },
  ];

  return DashBord;
};

